import {} from "../../utils";
// A deleted user is held as a placeholder which is never updated, so we never request updates for them
const DELETED_USER_UPDATED = BigInt(Number.MAX_VALUE);
export function deletedUser(userId) {
    return {
        kind: "user",
        userId,
        blobUrl: "/assets/deletedUser.svg",
        username: "Deleted User",
        displayName: undefined,
        updated: DELETED_USER_UPDATED,
        suspended: false,
        diamondStatus: "inactive",
        chitBalance: 0,
        streak: 0,
        maxStreak: 0,
        isUniquePerson: false,
        totalChitEarned: 0,
        hideOnlineStatus: false,
    };
}
export function isDeletedUser(user) {
    return user?.updated === DELETED_USER_UPDATED;
}
// Note this *has* to return UserSummary | undefined because of the types, but we would not expect it to ever do so in practice
export function mergeUserSummaryWithUpdates(cached, updates, timestamp) {
    if (cached === undefined) {
        if (updates.stable === undefined || updates.volatile === undefined) {
            // in this case we cannot construct a valid UserSummary - this should not happen
            return undefined;
        }
        return {
            kind: updates.stable.isBot ? "bot" : "user",
            userId: updates.userId,
            ...updates.stable,
            ...updates.volatile,
            updated: timestamp,
        };
    }
    if (cached.userId !== updates.userId) {
        return undefined;
    }
    return {
        ...cached,
        ...updates.stable,
        ...updates.volatile,
    };
}
// problem - we can no longer create a UserSummary from a CurrentUserSummary
export function userSummaryFromCurrentUserSummary(currentSummary) {
    return {
        kind: currentSummary.isBot ? "bot" : "user",
        userId: currentSummary.userId,
        username: currentSummary.username,
        displayName: currentSummary.displayName,
        updated: currentSummary.updated,
        suspended: currentSummary.suspensionDetails !== undefined,
        diamondStatus: currentSummary.diamondStatus.kind,
        chitBalance: currentSummary.chitBalance,
        totalChitEarned: currentSummary.totalChitEarned,
        streak: currentSummary.streak,
        maxStreak: currentSummary.maxStreak,
        blobReference: currentSummary.blobReference,
        blobData: currentSummary.blobData,
        blobUrl: currentSummary.blobUrl,
        isUniquePerson: currentSummary.isUniquePerson,
        hideOnlineStatus: currentSummary.hideOnlineStatus,
    };
}
export function updateCreatedUser(created, summary) {
    return {
        ...created,
        ...summary,
        kind: "created_user",
    };
}
export var UserStatus;
(function (UserStatus) {
    UserStatus[UserStatus["Offline"] = 0] = "Offline";
    UserStatus[UserStatus["Online"] = 1] = "Online";
    UserStatus[UserStatus["None"] = 2] = "None";
})(UserStatus || (UserStatus = {}));
export var AvatarSize;
(function (AvatarSize) {
    AvatarSize[AvatarSize["Tiny"] = 0] = "Tiny";
    AvatarSize[AvatarSize["Small"] = 1] = "Small";
    AvatarSize[AvatarSize["Default"] = 2] = "Default";
    AvatarSize[AvatarSize["Large"] = 3] = "Large";
})(AvatarSize || (AvatarSize = {}));
export const ANON_USER_ID = "does_this_need_to_be_a_principal";
export const ANON_USERNAME = "guest_user";
export const ANON_DISPLAY_NAME = "Guest user";
export const ANON_AVATAR_URL = "/assets/anon.svg";
export function anonymousUser() {
    return {
        kind: "created_user",
        username: ANON_USERNAME,
        dateCreated: BigInt(0),
        displayName: ANON_DISPLAY_NAME, // TODO probably need to translate this
        cryptoAccount: "", // TODO - will this be a problem?
        userId: ANON_USER_ID,
        isPlatformModerator: false,
        isPlatformOperator: false,
        suspensionDetails: undefined,
        isSuspectedBot: false,
        diamondStatus: { kind: "inactive" },
        moderationFlagsEnabled: 0,
        isBot: false,
        updated: 0n,
        isUniquePerson: false,
        totalChitEarned: 0,
        chitBalance: 0,
        streak: 0,
        maxStreak: 0,
        hideOnlineStatus: false,
        // The anonymous user never sees the terms-updated notice; acceptance is captured when
        // an account is registered or next used
        acceptedTermsVersion: Number.MAX_SAFE_INTEGER,
    };
}
export const ModerationFlags = {
    Offensive: 1,
    Adult: 2,
    UnderReview: 4,
};
